import type { ShouldRevalidateFunction } from '@remix-run/react';

import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

import { SPACE_MEMBERSHIP_ACTION } from '../_hooks/useSpaceMembershipFetcher';

// Form actions whose settles shouldn't re-run community child route loaders —
// SPACE_MEMBERSHIP_ACTION is handled by the community layout opting itself in.
const SKIP_REVALIDATION_FORM_ACTIONS: ReadonlySet<string> = new Set([SPACE_MEMBERSHIP_ACTION]);

export const isAnswerQuestionReload: ShouldRevalidateFunction = ({ currentUrl, nextUrl }) =>
  currentUrl.searchParams.get('modal') === 'community_answer_question' && currentUrl.href === nextUrl.href;

export const shouldRevalidateCommunityRoute: ShouldRevalidateFunction = (args) => {
  if (args.formAction && SKIP_REVALIDATION_FORM_ACTIONS.has(args.formAction)) return false;
  return shouldRevalidateLoaderData(args);
};
